import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { useAuth } from '@auth';
import { routes } from '@/shared/routes';
import GlassCard from '@/app/components/GlassCard';
import PublicLayout from '@/app/layouts/PublicLayout';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const handleNavigateHome = () => {
    navigate(isAuthenticated ? routes.app.root : routes.app.signin);
  };

  return (
    <PublicLayout centered>
      <GlassCard>
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-slate-400">
          <FormattedMessage id="notFound.code" />
        </p>
        <h1 className="mt-3 text-3xl font-semibold text-slate-900">
          <FormattedMessage id="notFound.heading" />
        </h1>
        <p className="mt-4 text-sm text-slate-600">
          <FormattedMessage id="notFound.description" />
        </p>
        <button
          type="button"
          onClick={handleNavigateHome}
          className="mt-8 inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-brand-600 to-accent-500 px-5 py-3 text-sm font-semibold text-white shadow-lg shadow-brand-200/60 transition hover:from-brand-500 hover:to-accent-400 focus:outline-none focus:ring-2 focus:ring-brand-300"
        >
          {isAuthenticated ? (
            <FormattedMessage id="notFound.backToDashboard" />
          ) : (
            <FormattedMessage id="notFound.backToSignIn" />
          )}
        </button>
      </GlassCard>
    </PublicLayout>
  );
}
